/* Loosn v10 — bundle picker, bag step before checkout, gallery (keeps srcset), sticky bar, demo video, scroll reveal. */
(function () {
  'use strict';
  var qty = 1;
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  document.querySelectorAll('.bundle').forEach(function (card) {
    card.addEventListener('click', function () {
      document.querySelectorAll('.bundle').forEach(function (c) { c.classList.remove('is-on'); });
      card.classList.add('is-on');
      qty = Number(card.getAttribute('data-qty')) || 1;
      var total = Number(card.getAttribute('data-total'));
      document.querySelectorAll('[data-buy-label]').forEach(function (el) {
        el.textContent = el.getAttribute('data-buy-label') + (total ? ' — ' + money(total) : '');
      });
      document.querySelectorAll('[data-sticky-price]').forEach(function (el) { if (total) el.firstChild.nodeValue = money(total); });
    });
  });

  /* Bag panel: one breath between "Buy now" and the checkout form. */
  var bag = null;
  function ensureBag() {
    if (bag) return bag;
    bag = document.createElement('div');
    bag.className = 'bag';
    bag.hidden = true;
    bag.innerHTML =
      '<div class="bag__scrim" data-bag-close></div>' +
      '<div class="bag__card" role="dialog" aria-modal="true" aria-labelledby="bag-title">' +
        '<button type="button" class="bag__x" aria-label="Close" data-bag-close>×</button>' +
        '<div class="eyebrow">Added to your bag</div>' +
        '<div class="bag__item"><img data-bag-img alt="" width="72" height="72"><div><b id="bag-title" data-bag-name></b><span data-bag-qty></span></div><div class="bag__price" data-bag-total></div></div>' +
        '<ul class="bag__trust"><li>Free US shipping, ships in 24h</li><li>30-day money-back guarantee</li><li>1-year warranty</li><li data-bag-offer hidden>Launch offer applied at checkout</li></ul>' +
        '<a class="btn btn--block" href="/checkout" data-bag-checkout>Continue to secure checkout</a>' +
        '<button type="button" class="bag__more" data-bag-close>Keep reading</button>' +
      '</div>';
    document.body.appendChild(bag);
    bag.addEventListener('click', function (e) { if (e.target.closest('[data-bag-close]')) closeBag(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bag.hidden) closeBag(); });
    return bag;
  }
  function openBag(item, cart) {
    var b = ensureBag();
    var img = b.querySelector('[data-bag-img]');
    if (item && item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2'); }
    b.querySelector('[data-bag-name]').textContent = (item && item.product_title) || 'Loosn massager';
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : ((item && item.quantity) || qty);
    b.querySelector('[data-bag-qty]').textContent = 'Qty ' + count + (count > 1 ? ' in your bag' : '');
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : (item ? item.final_line_price : 0);
    b.querySelector('[data-bag-total]').textContent = money(total);
    var onSale = !!document.querySelector('[data-countdown]');
    b.querySelector('[data-bag-offer]').hidden = !onSale;
    b.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var c = b.querySelector('[data-bag-checkout]'); if (c) c.focus(); }, 40);
  }
  function closeBag() { if (!bag) return; bag.hidden = true; document.body.style.overflow = ''; }

  function buy(variantId, btn) {
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        var item = res && res.items ? res.items[0] : res;
        return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; })
          .then(function (cart) { btn.disabled = false; btn.textContent = original; openBag(item, cart); });
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = original;
        var form = btn.closest('form');
        if (form) { var q = form.querySelector('[name=quantity]'); if (q) q.value = qty; form.submit(); }
      });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy]');
    if (!btn) return;
    e.preventDefault();
    buy(btn.getAttribute('data-buy'), btn);
  });

  /* Gallery: swap the main image but keep a responsive srcset so phones don't download 1100px. */
  var main = document.querySelector('[data-hero-img]');
  var frame = document.querySelector('.gallery__main');
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t || !main) return;
    var src = t.getAttribute('data-thumb');
    var small = t.getAttribute('data-thumb-small') || src;
    main.classList.add('is-fading');
    var img = new Image();
    img.onload = function () {
      main.srcset = small + ' 700w, ' + src + ' 1100w';
      main.src = src;
      main.classList.remove('is-fading');
    };
    img.src = src;
    if (frame) frame.classList.toggle('is-glow', t.hasAttribute('data-glow'));
    document.querySelectorAll('[data-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
    t.setAttribute('aria-current', 'true');
  });

  var sticky = document.querySelector('.sticky');
  var sentinel = document.querySelector('[data-sticky-sentinel]');
  if (sticky && sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(sentinel);
  }

  /* Demo video: only starts (and only downloads) once it's on screen. */
  var demo = document.querySelector('[data-demo-video]');
  if (demo && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { if (demo.preload === 'none') demo.preload = 'auto'; demo.play().catch(function () {}); }
        else { demo.pause(); }
      });
    }, { threshold: 0.35 }).observe(demo);
  }

  /* Scroll reveal: progressive. Elements are visible by default; JS adds the hidden
     state only when IntersectionObserver exists and motion is allowed. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll(
      'main .sec .center, main .sec > .wrap > *:not(.center), .benefit, .feature, .card, .symptom, .cmp, .review, .guar, .gift > *, .faq details, .signup__in > *'
    );
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var i = 0;
    targets.forEach(function (el) {
      if (el.closest('.hero') || el.closest('.sticky') || el.closest('.lp')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) return; // already on screen at load: never hide it
      el.classList.add('rv');
      el.style.transitionDelay = ((i++ % 6) * 60) + 'ms';
      io.observe(el);
    });
  }
})();
